import React, { useState, useEffect } from "react";
import "./TypingEffect.css";

const TypingEffect = ({ texts }) => {
    const [currentText, setCurrentText] = useState("");
    const [textIndex, setTextIndex] = useState(0);

    useEffect(() => {
        let charIndex = 0;
        const text = texts[textIndex];

        const typingInterval = setInterval(() => {
            setCurrentText((prev) => text.substring(0, charIndex + 1));
            charIndex++;

            if (charIndex === text.length) {
                clearInterval(typingInterval);
            }
        }, 100); // Velocità di scrittura

        const changeTextTimeout = setTimeout(() => {
            setTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
            setCurrentText("");
        }, 5000); // Cambia testo ogni 10 secondi

        return () => {
            clearInterval(typingInterval);
            clearTimeout(changeTextTimeout);
        };
    }, [textIndex, texts]);

    return <span className="typing">{currentText}</span>;
};

export default TypingEffect;